import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
import { buttonClass } from '../utils/styles';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  busy = false,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    cancelRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !busy) onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      previous?.focus();
    };
  }, [open, busy, onCancel]);
  return <AnimatePresence data-id="element-122" data-mp="1yzwepk9flkli">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.18,
      ease: 'easeOut'
    }} onMouseDown={e => {
      if (e.target === e.currentTarget && !busy) onCancel();
    }} data-id="element-123" data-mp="1z0xt9ypnop7z">
          <motion.div role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-description" initial={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-md rounded-xl border border-graphite bg-coal p-6 shadow-2xl" data-id="element-124" data-mp="1g8ddniyywgm4">
            <h2 id="confirm-title" className="font-display text-lg font-bold text-white" data-id="element-125" data-mp="35ntb413j4dw6">
              {title}
            </h2>
            <p id="confirm-description" className="mt-2 text-sm leading-relaxed text-mist" data-id="element-126" data-mp="344tbxa0butah">
              {description}
            </p>
            <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end" data-id="element-127" data-mp="2u884yj4qz840">
              <button ref={cancelRef} type="button" onClick={onCancel} disabled={busy} className={buttonClass('outline', 'md')} data-id="element-128" data-mp="2q7wlh9o4fdu4">
                Cancelar
              </button>
              <button type="button" onClick={onConfirm} disabled={busy} className={buttonClass('primary', 'md')} data-id="element-129" data-mp="3hyklujhz0f6q">
                {busy && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-130" data-mp="3d7ca3gt64hqe" />}
                {confirmLabel}
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}